
<div id="prefooter" class="section">
    <!-- container -->
    <div class="container">
        <!-- row -->
        <div class="row">
            <div class="col-md-12">
                <div class="footerstart">
                   
                    <div class="col-md-4 col-xs-4">
                        <i class="fa fa-flag"></i>
                            <div class="biggercopy">NATIONAL DELIVERIES</div>
                            <div class="smallcopy">
                                7 Warehouses across South Africa
                            </div>
                    </div>
                    
                    <div class="col-md-4 col-xs-4"><i class="fa fa-shopping-cart"></i>
                        <div class="biggercopy">LARGE PRODUCT RANGE</div>
                        <div class="smallcopy">Over 3000 products listed </div>
                    </div>
             
                </div>
            </div>
        </div>
    </div>
</div>
<div id="footer"><a routerLink="/">
        <!-- top footer -->
    </a>
    <div class="section"><a routerLink="/">
            <!-- container -->
        </a>
        <div class="container"><a routerLink="/">
                <!-- row -->
            </a>
            <div class="row"><a routerLink="/">
                </a>
                <div class="col-md-3 col-xs-12"><a routerLink="/">
                    </a>
                    <div class="footer">
                            <h3 class="footer-title">USEFUL LINKS</h3><a routerLink="/">
                        </a>
                        <ul class="footer-links"><a routerLink="/">
                                <li></li>
                            </a>
                            <li *ngIf="hasValidToken"><a routerLink="/account-dashboard">My Account</a></li>
                            <li><a routerLink="/contact">Contact</a></li>
                            <li *ngIf="hasValidToken"><a routerLink="/wish-list">Wishlist</a></li>
                            <li *ngIf="hasValidToken"><a routerLink="/cart">Checkout</a></li>
                            <li><a href="../../../../assets/downloads/SGC-CellaTerms.pdf" target="_blank">Terms &amp; Conditions</a></li>
                            <li><a href="https://www.facebook.com/sgconvenience/" target="_blank">Facebook</a></li>
                            <li><a routerLink="/access-to-information">Access to Information (PAIA)</a></li>
                        </ul>
                    </div>
                </div>

                <div class="clearfix visible-xs"></div>
                <div class="col-md-5 col-xs-12">
                    <div class="footer">
                        <h3 class="footer-title">HEAD OFFICE</h3>
                        <ul class="footer-links">
                            <li><a href="https://goo.gl/maps/6bUpb2YNKvXySxPH8" target="_blank"><i class="fa fa-map-marker"></i>Cnr Barbara &amp; Brollo Road, Isando,
                                    Kempton Park, 1601</a></li>
                            <li><i class="fa fa-phone"></i><a class="white-anchor" href="tel:0860747877">(0860) 747-877</a></li>
                            <li><i class="fa fa-envelope-o"></i><a class="white-anchor" href="mailto:info@sgconvenience.co.za?Subject=Cella%20Shop%20Enquiry"
                                target="_top">info@sgconvenience.co.za</a></li>
                            <li><i class="fa fa-clock-o"></i>Mon - Fri / 8:00AM - 6:00PM</li>
                            <li><img src="/assets/images/aware.jpg" width="132" height="39"></li>
                            <li><img src="/assets/images/sg-footer-logo.png" width="178" height="27"></li>
                        </ul>

                    </div>
                </div>
                <div class="col-md-4 col-xs-12">
                    <div class="footer">
                        <h3 class="footer-title">Location</h3>
                        <ul class="footer-map">
                            <!-- <li><img src="/assets/images/map-holder.png" width="359" height="100"></li> -->
                            <li><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.294539058772!2d28.199671399999996!3d-26.154535400000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9513d1a26acc1d%3A0x1e4ce01de6f48c14!2sSG%20Convenience%2CGermiston!5e0!3m2!1sen!2sza!4v1698219052624!5m2!1sen!2sza" width="100%" max-width="359" height="100" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- /row -->
        </div>
        <!-- /container -->
    </div>
</div>
<div id="bottom-footer" class="section">
    <div class="container">
        <!-- row -->
        <div class="row">
            <div class="container">
                <ul class="footerend pull-left">
                    Copyright © 2025 all rights reserved
                </ul>
                <ul class="footerend pull-right">

                    Designed &amp; Developed by Supergroup IT services
                </ul>
            </div>
        </div>
        <!-- /row -->
    </div>
    <div class="progress-bar" [ngClass]="{'show': isScrolling}">
        <button class="back-to-top" (click)="topFunction()">
            <svg xmlns="http://www.w3.org/2000/svg" class="back-to-top-icon" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11l5-5m0 0l5 5m-5-5v12">
                </path>
            </svg>
        </button>
    </div>


</div>
